import React, { useEffect, useState } from "react";
import { FiBell } from "react-icons/fi";
import { BiLogOutCircle } from "react-icons/bi";
import { AiOutlineUser } from "react-icons/ai";
import { CgMoveLeft } from "react-icons/cg";

import hr_text_white from "../../assets/branding/hr-text-white1.png";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setPage } from "../../store/userSlice";
import Dashboard from "./components/Dashboard/Dashboard";
import Profile from "./components/Profile/Profile";
import { Link, Outlet, useLoaderData, useNavigate } from "react-router-dom";
import Shimmer from "../../utils/Shimmer";
import axios from "../../axios";
import Breadcrumb from "../../utils/BreadCrumb";

export default function Main({ navbarOpen, setNavbarOpen, blockData }) {
  // const loaderData = useLoaderData();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { dashboardPage } = useSelector((state) => state.user);
  const { breadCrumbs } = useSelector((state) => state.user);

  const dashboardData = useSelector((state) => state.dashboardData);

  let user = {},
    user_detail = {},
    imageUrl;
  if (!blockData) {
    user = dashboardData?.data?.user;
    user_detail = user?.user_detail;
    // console.log("dashboardData.......",user_detail)
    imageUrl = user_detail?.profile_image_path;
    console.log("dashboardData.......",imageUrl)

  }

  return (
    <div
      className={`${
        navbarOpen && ""
      }  min-h-screen h-auto md:max-w-lg lg:max-w-xl xl:max-w-none min-w-full w-full  dark:bg-dark dark:text-white sm:pl-[17rem] ${
        dashboardPage === "Project" ? "bg-white" : "bg-slate-100"
      }`}
    >
      <div className="bg-indigo dark:bg-dark text-white w-full flex justify-between items-center p-2 sm:hidden">
        <img src={hr_text_white} alt="logo" width={100} />
        <CgMoveLeft
          size={"1.5rem"}
          className="mr-4 sm:pointer-events-none"
          onClick={() => setNavbarOpen((p) => !p)}
        />
      </div>
      <div className="w-full bg-white dark:bg-dark2 p-5  justify-between items-center hidden sm:flex">
        {/* <p className="font-bold uppercase">{dashboardPage}</p> */}
        {/* <p className="font-bold uppercase">SOUNDLINE DASHBOARD</p> */}
        <Breadcrumb items={breadCrumbs} />
        <div className="flex gap-6 items-center relative">
          <FiBell size={"1.2rem"} />
          <Link to="/dashboard/edit-profile">
            <div className="" onClick={() => dispatch(setPage("Edit Profile"))}>
              <img
                src={imageUrl}
                // src="/static/media/hr-text-white1.a3a16420b663e6553d56.png"
                alt="user"
                className="w-7 h-7 rounded-full  mx-5"
              />
              {/* <img src="/static/media/hr-text-white1.a3a16420b663e6553d56.png" alt="logo" className="w-20 h-15 rounded-full mx-5"></img> */}
            </div>
          </Link>
          {/* <div className="hidden absolute top-7 right-5 max-w-xs w-[17rem] h-auto bg-white shadow-md rounded-lg p-2 dark:bg-dark2 ring-1 ring-slate-400 dark:ring-black peer-hover:block hover:block z-50">
            <Link to="/dashboard/edit-profile">
              <p className="bg-white shadow-sm  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                <AiOutlineUser /> {user.name}
              </p>
            </Link>
            <p
              className="bg-white p-2 w-full hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3"
              onClick={() => {
                localStorage.removeItem("token");
                navigate("/login");
              }}
            >
              <BiLogOutCircle /> Sign Out
            </p>
          </div> */}
        </div>
      </div>
      <p className="p-1 px-2 sm:hidden">{dashboardPage}</p>
      {dashboardPage === "Dashboard" && <Dashboard />}
      {dashboardPage === "Edit Profile" && <Profile />}
      <div className="w-full overflow-x-auto" id="main-page">
        {dashboardPage !== "Edit Profile" && <Outlet />}
      </div>
    </div>
  );
}
